(function () {
  document.addEventListener(
    'click',
    function (event) {
      var form = event.target.closest && event.target.closest('[data-quick-add-form]');
      if (!form) return;
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-quick-add-form]')) return;
      event.preventDefault();
      if (form.isSubmitting) return;
      form.isSubmitting = true;

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer) return null;
          return fetch(window.location.pathname + '?sections=cart-drawer')
            .then(function (response) {
              if (!response.ok) throw new Error('cart drawer ' + response.status);
              return response.json();
            })
            .then(function (data) {
              if (!data['cart-drawer']) return;
              var parser = new DOMParser();
              var next = parser.parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
              if (!next) return;
              cartDrawer.innerHTML = next.innerHTML;
              cartDrawer.classList.remove('is-empty');
              setTimeout(function () {
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
                else cartDrawer.classList.add('animate', 'active');
              }, 100);
            });
        })
        .catch(function () {})
        .then(function () {
          form.isSubmitting = false;
        });
    },
    true
  );
})();
